/**
 * 현장별 전화·카톡 상담 연결 여부 — 한 곳에서만 판단한다 (2026-09-26 대표 결정).
 *
 * "지금 특별 현장 외에는 담당자가 없다. 카톡 상담 및 1533-8124 로 연결되면 안 된다."
 *   - DB: Property.save() 가 is_side_inquiry = not is_special 로 강제 (백엔드 규칙·데이터 점검 'contact_mode_mismatch')
 *   - 프론트: 이 함수만 보고 전화 버튼·카톡 버튼·하단 통화 바·'정확한 금액은 1533-8124 상담' 문구를 그린다.
 *
 * fail-closed: 담당자 있음(is_side_inquiry === false)이 명확할 때만 true.
 *   값이 없거나(API 누락·로딩 중) 애매하면 연결하지 않는다.
 */
export interface ContactPolicyInput {
  is_side_inquiry?: boolean | null;
}

export const canContactProperty = (p?: ContactPolicyInput | null): boolean => p?.is_side_inquiry === false;
